import { Helmet } from 'react-helmet-async';

// Organization Schema
const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Tetralog Ltd.",
  "alternateName": "Тетралог ЕООД",
  "url": "https://www.tetralog.bg",
  "logo": "https://www.tetralog.bg/images/logo.png",
  "description": "International transport and logistics company based in Sofia, Bulgaria. Over 20 years of experience in cargo transport across Europe.",
  "foundingDate": "2003",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Industrial Zone West",
    "addressLocality": "Sofia",
    "addressCountry": "BG"
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+359-888-111-222",
      "contactType": "customer service",
      "availableLanguage": ["Bulgarian", "English"]
    },
    {
      "@type": "ContactPoint",
      "telephone": "+359-888-333-444",
      "contactType": "sales",
      "availableLanguage": ["Bulgarian", "English"]
    }
  ],
  "email": "angeliw@tetralog.bg",
  "sameAs": [
    "https://www.facebook.com/tetralog",
    "https://www.instagram.com/tetralog"
  ]
};

// LocalBusiness Schema
const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "MovingCompany",
  "name": "Tetralog Ltd.",
  "image": "https://www.tetralog.bg/images/og-image.jpg",
  "url": "https://www.tetralog.bg",
  "telephone": "+359-888-111-222",
  "email": "angeliw@tetralog.bg",
  "priceRange": "$$",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Industrial Zone West",
    "addressLocality": "Sofia",
    "addressRegion": "Sofia-city",
    "postalCode": "1000",
    "addressCountry": "BG"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 42.6977,
    "longitude": 23.3219
  },
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "08:00",
      "closes": "18:00"
    }
  ],
  "areaServed": {
    "@type": "GeoCircle",
    "geoMidpoint": {
      "@type": "GeoCoordinates",
      "latitude": 48.8566,
      "longitude": 2.3522
    },
    "geoRadius": "3000000"
  },
  "serviceType": [
    "International Transport",
    "Logistics",
    "Express Delivery",
    "Groupage Transport",
    "Moving Services",
    "Specialized Cargo"
  ]
};

// WebSite Schema with SearchAction
const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Tetralog Ltd.",
  "url": "https://www.tetralog.bg",
  "inLanguage": ["bg", "en"],
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://www.tetralog.bg/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

// BreadcrumbList Schema Generator
export const generateBreadcrumbSchema = (items) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };
};

// Service Schema Generator
export const generateServiceSchema = (service) => {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": service.name,
    "provider": {
      "@type": "Organization",
      "name": "Tetralog Ltd."
    },
    "description": service.description,
    "areaServed": {
      "@type": "Place",
      "name": "Europe"
    }
  };
};

// FAQ Schema Generator
export const generateFAQSchema = (faqItems) => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems.map(item => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };
};

// Main StructuredData Component
export const StructuredData = ({ type = 'organization', data = null }) => {
  let schema;
  
  switch (type) {
    case 'organization':
      schema = organizationSchema;
      break;
    case 'localBusiness':
      schema = localBusinessSchema;
      break;
    case 'website':
      schema = websiteSchema;
      break;
    case 'breadcrumb':
      schema = data ? generateBreadcrumbSchema(data) : null;
      break;
    case 'service':
      schema = data ? generateServiceSchema(data) : null;
      break;
    case 'faq':
      schema = data ? generateFAQSchema(data) : null;
      break;
    default:
      schema = organizationSchema;
  }

  if (!schema) return null;

  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ 
      __html: JSON.stringify(schema) 
    }} />
  );
};

// Combined schemas for homepage - renders JSON-LD directly
export const HomePageStructuredData = () => {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ 
        __html: JSON.stringify(organizationSchema) 
      }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ 
        __html: JSON.stringify(localBusinessSchema) 
      }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ 
        __html: JSON.stringify(websiteSchema) 
      }} />
    </>
  );
};

export default StructuredData;
